'use strict';
var _ = require("lodash");
var $ = require("jquery");
var Backbone = require("backbone");

var PICTURE_LARGE   = 'large';
var PICTURE_NORMAL  = 'normal';
var PICTURE_SMALL   = 'small';
var PICTURE_SQUARE  = 'square';

var NOT_AUTHORIZED  = 'not_authorized';
var DISCONNECTED    = 'disconnected';
var CONNECTED       = 'connected';

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

module.exports = Backbone.Model.extend({
    defaults: {
        appId: '',
        status: '',
        age_range: null,
        email: '',
        id: '',
        name: '',
        permissions: null,
        pictures: null,
        authResponse: null
    },

    options: {
        autoUpdateLoginStatus: true,
        autoLoadUserData: true,
        scope: '',
        version: 'v2.12',
        manageFbloCookie: true
    },

    initialize: function(attributes, options) {
        _.bindAll(this, 'updateLoginStatus');

        options || (options = {});
        _.extend(this.options, options);

        if(typeof FB === 'object' && !_.isUndefined(window.fbAsyncInit)){
            this.onScriptLoaded();
            return;
        } else {
            window.fbAsyncInit = this.onScriptLoaded.bind(this);
            this.loadScript(document, 'script', 'facebook-jssdk');
        }
    },

    loadScript: function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    },

    onScriptLoaded: function() {
        this._scriptLoaded = true;

        FB.init({
            appId      : this.get('appId'),
            xfbml      : true,
            version    : this.options.version,
            cookie     : true
        });

        if(this.options.autoUpdateLoginStatus) {
            this.getLoginStatus();
        }
    },

    isConnected: function() {
        return this.get('status') === 'connected';
    },

    login: function(options){
        if(!this._scriptLoaded) {
            throw new Error('Facebook User Model: Login cannot be called before the SDK is loaded.');
        }

        if(this.options.manageFbloCookie) {
            //After login, clear this cookie.
            eraseCookie('fblo_' + this.get('appId'));
        }

        var deferred = $.Deferred();

        var callback = function(response) {
            this.updateLoginStatus(response).then(function() {
                if(response.status === CONNECTED) {
                    deferred.resolve(response);
                } else {
                    deferred.reject(response);
                }
            });
        }.bind(this);

        var opts = _.extend({
            scope: this.options.scope,
            return_scopes: true
        }, options);

        FB.login(callback, opts);
        return deferred;
    },

    logout: function(callback){
        if(!this._scriptLoaded) {
            throw new Error('Facebook User Model: Logout cannot be called before the SDK is loaded.');
        }

        FB.getLoginStatus(function(response) {
            if(response.status === 'connected' || response.status === 'not_authorized') {
                FB.logout(callback);
            } else {
                this.updateLoginStatus(response);
                if(typeof callback === 'function') {
                    callback();
                }
            }
        }.bind(this), true);
    },

    api: fbapi,
    ui: fbui,

    getLoginStatus: function(){
        if(!this._scriptLoaded) {
            throw new Error('Facebook User Model: UpdateLoginStatus cannot be called before the SDK is loaded.');
        }

        FB.getLoginStatus(this.updateLoginStatus);
    },

    updateLoginStatus: function(response) {
        this.set('authResponse', response.authResponse);

        if(response.status === CONNECTED && this.options.autoLoadUserData) {
            return this.fetch().done(function(response) {
                this.set('status', CONNECTED);
            }.bind(this));
        } else {
            this.set('status', response.status);
            return $.Deferred().resolve();
        }
    },

    parse: function(response) {
        var attributes = _.extend(response, {
            pictures: this.profilePictureUrls(response.id)
        });

        if(response.permissions) {
            var permissions = _.filter(response.permissions.data, function(p) {
                return p.status == 'granted';
            });

            attributes.permissions = _.map(permissions, function(p) {
                if(p.status == 'granted') {
                    return p.permission;
                }
            });
        }

        return attributes;
    },

    sync: function(method, model, options) {
        if(method !== 'read') throw new Error('FacebookUser is a readonly model, cannot perform ' + method);

        var deferred = $.Deferred();
        console.log('sync!');
        var callback = function(response) {
            if(response.error) {
                if(options.error) {
                    options.error(response);
                }
                deferred.reject(response);
            } else {
                if(options.success) {
                    options.success(response);
                }
                deferred.resolve(response);
            }
            return true;
        }.bind(this);

        var request = FB.api('/me?fields=id,name,permissions,age_range,email,first_name,last_name,gender', callback);

        return deferred;
    },

    profilePictureUrls: function(id) {
        id || (id = this.id);
        var urls = {};

        _.each([ PICTURE_SQUARE, PICTURE_SMALL, PICTURE_NORMAL, PICTURE_LARGE ], function(size){
            urls[size] = this.profilePictureUrl(id, size);
        }, this);

        return urls;
    },

    profilePictureUrl: function(id, size) {
        size = size || PICTURE_LARGE;

        return [
            'https://graph.facebook.com/',
            id,
            '/picture?type=',
            size,
            '&return_ssl_resources=1'
        ].join('');
    }

}, {
    PICTURE_SMALL: PICTURE_SMALL,
    PICTURE_LARGE: PICTURE_LARGE,
    PICTURE_NORMAL: PICTURE_NORMAL,
    PICTURE_SQUARE: PICTURE_SQUARE,
    NOT_AUTHORIZED: NOT_AUTHORIZED,
    DISCONNECTED: DISCONNECTED,
    CONNECTED: CONNECTED
});


function facebookAPIWrapper(args) {
    var userCallback = args[args.length - 1];

    var def = $.Deferred();

    var wrappedCallback = function(response) {
        if(typeof userCallback === 'function') {
            userCallback(response);
        }
        def.resolve(response);
    };

    if(typeof userCallback === 'function') {
        //If the user provided a callback,
        //let's overwrite it with our wrapped version.
        args[args.length - 1] = wrappedCallback;
    } else {
        //If the user didn't provide a callback,
        //let's add our own callback to the end of the param list.
        //This will allow the use of Deferred/Promise pattern.
        args.push(wrappedCallback);
    }

    return def;
}

function fbui() {
    if(!this._scriptLoaded) {
        throw new Error('Facebook User Model: "FB.ui" cannot be called before the SDK is loaded.');
    }

    var args = Array.prototype.slice.call(arguments);
    var def = facebookAPIWrapper(args);

    FB.ui.apply(this, args);

    return def;
}

function fbapi() {
    if(!this._scriptLoaded) {
        throw new Error('Facebook User Model: "FB.api" cannot be called before the SDK is loaded.');
    }

    var args = Array.prototype.slice.call(arguments);
    var def = facebookAPIWrapper(args);

    FB.api.apply(this, ret.args);

    return def;
}
